import { ToolCallCard } from './tool-call-card';

interface InlineToolCallProps {
  toolName: string;
  toolDisplayName?: string;
  toolCallId: string;
  args: Record<string, unknown>;
  result?: unknown;
  isError?: boolean;
  status?: { type: string };
  durationMs?: number;
}

/**
 * Compact inline rendering for tool calls inside the thinking section.
 * Delegates to ToolCallCard in compact mode.
 */
export function InlineToolCall(props: InlineToolCallProps) {
  return <ToolCallCard {...props} compact />;
}
